import { m } from "@/paraglide/messages";
import type { Tool } from "../index";

export const bubbleChartTool: Tool = {
  id: "bubble-chart",
  name: () => m.bubble_tool_name(),
  description: () => m.bubble_tool_description(),
  icon: "🫧",
  basePath: "/bubble-chart",
  status: "stable",
  tags: ["chart", "plot", "data-visualization", "bubble-chart", "science"],
};
